import getField from '../getField'
import { parserFor } from './calculateStatistics'

// get a given field's value in it's chosen unit
const getValueInUnit = (field, unit) => {
	const value = parserFor(unit || getField(field, 'unit'))(getField(field, 'value', unit || getField(field, 'unit') || []), unit)
	return value
}

export default getValueInUnit



// WEBPACK FOOTER //
// ./src/utilities/Data/User/getValueInUnit.js